__turbopack_context__.v({
  "allpackages": "Packages-module-scss-module__3kCiia__allpackages",
  "checkout_mian": "Packages-module-scss-module__3kCiia__checkout_mian",
  "checkout_row": "Packages-module-scss-module__3kCiia__checkout_row",
  "common_btn_parent": "Packages-module-scss-module__3kCiia__common_btn_parent",
  "delete_item": "Packages-module-scss-module__3kCiia__delete_item",
  "discounted_price": "Packages-module-scss-module__3kCiia__discounted_price",
  "form_group": "Packages-module-scss-module__3kCiia__form_group",
  "form_label": "Packages-module-scss-module__3kCiia__form_label",
  "form_sec": "Packages-module-scss-module__3kCiia__form_sec",
  "grow": "Packages-module-scss-module__3kCiia__grow",
  "offered_price": "Packages-module-scss-module__3kCiia__offered_price",
  "package_band": "Packages-module-scss-module__3kCiia__package_band",
  "package_child": "Packages-module-scss-module__3kCiia__package_child",
  "package_child_detail": "Packages-module-scss-module__3kCiia__package_child_detail",
  "package_detail": "Packages-module-scss-module__3kCiia__package_detail",
  "package_price": "Packages-module-scss-module__3kCiia__package_price",
  "package_ribbon": "Packages-module-scss-module__3kCiia__package_ribbon",
  "packages_sec": "Packages-module-scss-module__3kCiia__packages_sec",
  "popup_alert": "Packages-module-scss-module__3kCiia__popup_alert",
  "price": "Packages-module-scss-module__3kCiia__price",
  "qnatity_btn": "Packages-module-scss-module__3kCiia__qnatity_btn",
  "quantity_items": "Packages-module-scss-module__3kCiia__quantity_items",
  "quantity_main": "Packages-module-scss-module__3kCiia__quantity_main",
  "quantity_main_text": "Packages-module-scss-module__3kCiia__quantity_main_text",
  "quantity_main_value": "Packages-module-scss-module__3kCiia__quantity_main_value",
  "quantity_popup": "Packages-module-scss-module__3kCiia__quantity_popup",
  "regular_price": "Packages-module-scss-module__3kCiia__regular_price",
  "right_detail": "Packages-module-scss-module__3kCiia__right_detail",
  "submit_button": "Packages-module-scss-module__3kCiia__submit_button",
  "subtotal": "Packages-module-scss-module__3kCiia__subtotal",
  "subtotal_child": "Packages-module-scss-module__3kCiia__subtotal_child",
});
